/**
 * Section contents rail for long policy pages.
 *
 * The Terms run 27 numbered sections and the Whatnot list is 16,000 words.
 * With a single centred column that is a long scroll with no sense of
 * position, while the space either side sits empty — so the rail both fills
 * that space and makes the document navigable.
 *
 * Built from the page's own <h2>s at runtime, so it stays correct when the
 * client's legal documents are revised. Adds nothing when a page has fewer
 * than four sections (Authenticity Guarantee, Shipping) — a contents list for
 * three headings is noise.
 */
(function () {
  function slug(text, i) {
    return (
      'sec-' +
      (text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 48) || 'x') +
      '-' + i
    );
  }

  function init(main) {
    const rte = main.querySelector('.rte');
    if (!rte || main.dataset.hofsmToc === 'on') return;
    // h2 is the normal section level; the Whatnot list is built from h3s, so
    // fall back to those when a page has no h2s at all.
    let heads = Array.from(rte.querySelectorAll('h2'));
    if (heads.length === 0) heads = Array.from(rte.querySelectorAll('h3'));
    if (heads.length < 4) return;

    heads.forEach((h, i) => { if (!h.id) h.id = slug(h.textContent.trim(), i); });

    const nav = document.createElement('nav');
    nav.className = 'hofsm-toc';
    nav.setAttribute('aria-label', 'Sections');
    nav.innerHTML =
      '<p class="hofsm-toc__title">Contents</p><ol class="hofsm-toc__list">' +
      heads.map((h) => `<li><a href="#${h.id}">${h.textContent.trim().replace(/^\d+\.\s*/, '')}</a></li>`).join('') +
      '</ol>';

    const wrap = document.createElement('div');
    wrap.className = 'hofsm-policy-layout';
    rte.parentNode.insertBefore(wrap, rte);
    wrap.appendChild(nav);
    wrap.appendChild(rte);

    // highlight the section currently in view
    const links = new Map(heads.map((h) => [h.id, nav.querySelector(`a[href="#${h.id}"]`)]));
    const seen = new Set();
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => (e.isIntersecting ? seen.add(e.target.id) : seen.delete(e.target.id)));
        links.forEach((a) => a && a.classList.remove('is-current'));
        const first = heads.find((h) => seen.has(h.id));
        if (first) links.get(first.id)?.classList.add('is-current');
      },
      { rootMargin: '-80px 0px -70% 0px' }
    );
    heads.forEach((h) => io.observe(h));

    main.dataset.hofsmToc = 'on';
  }

  const boot = () => document.querySelectorAll('[id$="__policy-main"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
